/* global axios */
import ApiClient from './ApiClient';

class CampaignContactGroupsAPI extends ApiClient {
  constructor() {
    super('campaign_contact_groups', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, payload);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  importCsv(formData) {
    return axios.post(`${this.url}/import_csv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new CampaignContactGroupsAPI();
